<template>
  <el-dialog title="新增故障事件" 
            :visible.sync="dialogVisible" 
            width="600px" 
            @close="resetForm"    
            :close-on-click-modal="false">
    <el-form
      :model="createForm"
      :rules="rules"
      ref="createForm"
      label-width="140px"
      size="small"
    >
      <!-- 各个表单项 -->
      
       <el-form-item label="合同ID：" prop="device_id">
        <el-input v-model="createForm.device_id" placeholder="请输入设备ID"></el-input>
      </el-form-item>
      <el-form-item label="设备ID：" prop="device_id">
        <el-input v-model="createForm.device_id" placeholder="请输入设备ID"></el-input>
      </el-form-item>
      <el-form-item label="故障类型：" prop="lease_scale">
        <el-select v-model="createForm.lease_scale" placeholder="请选择故障类型" style="width: 100%;">
          <el-option label="任意" :value="0"></el-option>
          <el-option label="整租" :value="1"></el-option>
          <el-option label="散租" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="故障等级：" prop="severity_level">
        <el-select v-model="createForm.severity_level" placeholder="请选择故障等级" style="width: 100%;">
          <el-option label="低" :value="1"></el-option>
          <el-option label="中" :value="2"></el-option>
          <el-option label="高" :value="3"></el-option>
          <el-option label="严重" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="故障开始时间：" prop="occurred_at">
        <el-date-picker v-model="createForm.occurred_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择故障开始时间" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="故障结束时间：" prop="resolved_at">
        <el-date-picker v-model="createForm.resolved_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择故障结束时间" style="width: 100%;"></el-date-picker>
      </el-form-item>

      <el-form-item label="实际时长(分钟)：" prop="actual_duration">
        <el-input v-model="createForm.actual_duration" placeholder="请输入GPU型号"></el-input>
      </el-form-item>
      <el-form-item label="折算时长(分钟)：" prop="conversion_duration">
        <el-input v-model="createForm.conversion_duration" placeholder="请输入GPU型号"></el-input>
      </el-form-item>
      <el-form-item label="状态：" prop="status">
        <el-select v-model="createForm.status" placeholder="请选择状态" style="width: 100%;">
          <el-option label="待确认" :value="0"></el-option>
          <el-option label="确认中" :value="1"></el-option>
          <el-option label="已处理" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="故障描述：" prop="description">
        <el-input type="textarea" rows="4" v-model="createForm.description" placeholder="请输入故障描述"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="submitForm('createForm')">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateProvider',
  data() {
    return {
      dialogVisible: false,
      createForm: {
        provider: '',
        location: '',
        contacts: '',
        provider_tel: '',
        gpu_model: '',
        scale: '',
        start_time: '',
        end_time: '',
        lease_scale: 0,
        lease_type: 0,
        status: 0,
        remark: ''
      },
      rules: {
        provider: [{ required: true, message: '请输入提供商', trigger: 'blur' }],
        location: [{ required: true, message: '请输入地理位置', trigger: 'blur' }],
        scale: [{ required: true, message: '请输入规模', trigger: 'blur' }],
        gpu_model: [{ required: true, message: '请输入GPU型号', trigger: 'blur' }],
        provider_tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
       
      }
    };
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.createForm.clearValidate();
      });
    },
    resetForm() {
      if (this.$refs.createForm) {
        this.$refs.createForm.resetFields();
      }
    },
    submitForm() {
      this.$refs.createForm.validate(valid => {
        if (!valid) return;
        const postData = { ...this.createForm };
        // 发送请求
        this.$axios.post('/api-30216/api/regions', postData)
          .then(res => {
            if (res.code === 200) {
              this.$message.success('新增成功');
              this.dialogVisible = false;
              this.$emit('success'); // 可以通过事件通知父组件刷新列表
            } else {
              this.$message.error(res.message || '新增失败');
            }
          })
          .catch(err => {
            this.$message.error('请求失败，请检查网络');
            console.error(err);
          });
      });
    }
  }
};
</script>

<style scoped>
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
</style>